import { ALL_ENTITY_TYPES } from '@localagent/sdk';
import type { EntityType } from '@localagent/sdk';

export const SESSION_EVENT_TYPE: EntityType = 'session_event';

export const DEFAULT_ENTITY_TYPES: readonly EntityType[] = ALL_ENTITY_TYPES.filter(
  (t) => t !== SESSION_EVENT_TYPE,
);

export interface EntityTypeLabel {
  singular: string;
  plural: string;
  icon: string;
}

export const ENTITY_TYPE_LABELS: Record<EntityType, EntityTypeLabel> = {
  workspace: { singular: 'Workspace', plural: 'Workspaces', icon: '📁' },
  team: { singular: 'Team', plural: 'Teams', icon: '👥' },
  project: { singular: 'Project', plural: 'Projects', icon: '📋' },
  initiative: { singular: 'Initiative', plural: 'Initiatives', icon: '🎯' },
  ticket: { singular: 'Ticket', plural: 'Tickets', icon: '🎫' },
  persona: { singular: 'Persona', plural: 'Personas', icon: '🤖' },
  automation: { singular: 'Automation', plural: 'Automations', icon: '⚙️' },
  integration: { singular: 'Integration', plural: 'Integrations', icon: '🔌' },
  tool_endpoint: { singular: 'Tool', plural: 'Tools', icon: '🔧' },
  session: { singular: 'Session', plural: 'Sessions', icon: '💬' },
  agent_process: { singular: 'Process', plural: 'Processes', icon: '🔀' },
  session_message: { singular: 'Session message', plural: 'Session messages', icon: '💬' },
  session_event: { singular: 'Session activity', plural: 'Session activity', icon: '⚡' },
  file: { singular: 'File', plural: 'Files', icon: '📄' },
  directory: { singular: 'Directory', plural: 'Directories', icon: '📂' },
  feed_post: { singular: 'Post', plural: 'Posts', icon: '📣' },
  account_skill: { singular: 'Skill', plural: 'Skills', icon: '✦' },
  account_artifact: { singular: 'Artifact', plural: 'Artifacts', icon: '🖼' },
  account_secret: { singular: 'Secret', plural: 'Secrets', icon: '🔑' },
};

export function resolveActiveEntityTypes(selected: readonly EntityType[]): EntityType[] {
  return selected.length === 0 ? [...DEFAULT_ENTITY_TYPES] : [...selected];
}
